<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    let {
        label = "",
        value = $bindable(),
        name = "",
        class: cls = "",
        inputClass = "",
        disabled = false,
        min = null,
        max = null,
        onchange = undefined,
    } = $props();

    const labelCls = $derived(twMerge(
        "tw:block tw:text-sm tw:font-medium tw:text-gray-900 tw:relative tw:w-full",
        cls,
    ));
    const inputCls = $derived(twMerge(
        "tw:bg-gray-50 tw:border tw:border-gray-300 tw:text-gray-900 tw:text-sm tw:rounded-lg tw:focus:ring-blue-500 tw:focus:border-blue-500 tw:block tw:w-full tw:px-2.5 tw:py-2",
        inputClass,
    ));
</script>

<label class={labelCls}>
    {#if label}{label}{/if}
    <input type="date"
           class={inputCls}
           {name}
           {disabled}
           {min}
           {max}
           bind:value={value}
           {onchange}>
</label>
